module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "logo"
  }, [(_vm.url) ? _c('a', {
    attrs: {
      "href": _vm.url,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.banner.atturl,
      "alt": "log"
    }
  })]) : _c('img', {
    attrs: {
      "src": _vm.banner.atturl,
      "alt": "log"
    },
    on: {
      "click": function($event) {
        return _vm.showTips('敬请期待！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "goods"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": _vm.good1.url,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.good1.atturl,
      "alt": "商品"
    }
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.good2.url,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.good2.atturl,
      "alt": "商品"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bb514d7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/middle-ads/block.vue
// module id = 1629
// module chunks = 1